<template>
    <div class="container-fluid mt-4 mb-4">
        <div class="hero">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="hero-content">
                            <h1 class="display-4 font-weight-bold  text-white">Device Details</h1>
                            <h4 class="font-weight-light  text-white">MANAGE DEVICE</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--Boxes-->
        <div v-if="device" class="boxes-hero">
            <div class="container">
                <div class="row equal">
                    <div class="col-md-6 my-2">
                        <div class="box shadow-lg bg-white rounded bg-icon-device">
                            <div class="box-header bg-light-blue p-3">
                                <div class="row">
                                    <div class="col">
                                        {{device.name}}
                                    </div>
                                    <b-link
                                            id="edit-device-link"
                                            @click="toggle_device_modal">
                                        <span style="margin-right:20px" class="icon-blue mx-1"><img src="/icons/icon-edit.png" height="15"></span>
                                    </b-link>
                                </div>

                            </div>
                            <div class="box-body p-3">
                                <b-table
                                        :id="`${tableName}-device-table`"
                                        :items="[device]"
                                        :fields="fields.device"
                                        stacked>

                                    <template v-slot:cell(status)="item">
                                        <span v-if="rssi">
                                            <img :src="get_rssi_img()" height="35">
                                        </span>
                                        <span style="margin-left: 20px;">
                                            <img :src="get_batt_img()" height="40">
                                        </span>
                                    </template>

                                    <template v-slot:cell(lastReportDateTime)="item">
                                        <span v-if="lastReportDateTime">
                                          {{lastReportDateTime | formatDateTime}}
                                        </span>
                                        <span v-else>
                                            unknown
                                        </span>
                                    </template>

                                </b-table>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 my-2">
                        <div class="box shadow-lg bg-white rounded bg-icon-location">
                            <div class="box-header bg-light-blue p-3">
                                <div class="row">
                                    <div class="col">
                                        Device Location
                                    </div>
                                    <b-link
                                            id="edit-address-link"
                                            @click="toggle_address_modal">
                                        <span style="margin-right:20px" class="icon-blue mx-1"><img src="/icons/icon-edit.png" height="15"></span>
                                    </b-link>
                                </div>
                            </div>
                            <div class="box-body p-3">
                                <b-table
                                        :id="`${tableName}-device-address-table`"
                                        :items="device_address ? [device_address] : []"
                                        :fields="fields.address_fields"
                                        stacked
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="device && (device.device_type_id == 3 || device.device_type_id == 6 || device.device_type_id == 9)" class="container">
            <div class="row equal">
                <div class="col-md-12 my-2" >
                    <div class="shadow-lg bg-white rounded">
                        <div class="box-header bg-light-blue p-3">
                            <div class="row">
                                <div class="col">
                                    Valve Control
                                </div>
                            </div>
                        </div>
                        <div class="p-3">
                            <div v-if="!disable_valve_control" class="text-center" style="font-weight: bold">
                                LAST VALVE COMMAND: {{ valve_status ? 'OPEN': 'CLOSED' }}
                                <br/><br/>
                                <b-button v-on:click="updateValveControl"
                                       :class="valve_status ? 'btn-close': 'btn-open'"
                                    >{{ valve_status ? 'CLOSE VALVE': 'OPEN VALVE' }}</b-button>
                                <br/><br/>
                                note: valve actuation may take up to 4 hours
                            </div>
                            <div v-if="disable_valve_control" class="d-flex align-items-center justify-content-center" style="font-weight: bold; font-size: 18px">
                                <router-link style="color: #296a9b" to="/billing">Upgrade to Premium to Activate Valve Control</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

      <div v-if="device" class="container">
        <div class="row equal">
          <div class="col-md-12 my-2" >
            <div class="shadow-lg bg-white rounded">
              <div class="box-header bg-light-blue p-3">
                <div class="row">
                  <div class="col">
                    Troubleshooting Mode
                  </div>
                </div>
              </div>
              <div class="p-3">
                <div class="text-center" style="font-weight: bold">
                  Troubleshooting Mode Support: {{ troubleshooting_mode_supported ? 'ENABLED': 'DISABLED' }}
                  <span v-if="troubleshooting_mode_supported && troubleshooting_mode_time">
                    <br/><br/>
                    mode last triggered at {{ troubleshooting_mode_time | formatDateTime }}
                  </span>
                  <br/><br/>
                  <b-button v-on:click="updateTroubleshootingMode">{{ troubleshooting_mode_supported ? 'CLICK HERE TO DISABLE': 'CLICK HERE TO ENABLE' }}</b-button>
                  <br/><br/>
                </div>
                  When support is enabled, the device will transmit data more frequently (every 5 minutes) for up to 30 minutes following any of these events:
                  <ul>
                    <li>a leak alert is detected</li>
                    <li>a high flow alert is detected</li>
                    <li>a valve is opened or closed</li>
                    <li>the magnet is applied to the device for 11-20 seconds</li>
                  </ul>
                  <b><i>caution: while this is useful for system troubleshooting, it will reduce battery life</i></b>
              </div>
            </div>
          </div>
        </div>
      </div>

        <div class="boxes mb-4">
            <div class="container">
                <div class="row equal">
                    <div class="col-md-12 my-2">
                        <div class="box shadow-lg bg-white rounded">
                            <div style="">
                                <b-card>
                                    <b-tabs content-class="mt-3" fill v-model="tabIndex">

                                        <b-tab title="Sensors">
                                            <k-sensor-list :items="sensors"
                                                           :fields="fields.sensors"
                                                           :busy="loading.sensorList"
                                                           :retrieve-sensor-mgs="retrieve_sensor_mgs"
                                                           :downloadSensorMgs="download_data"
                                                           :fields-sensor-msgs="fields.sensor_msgs"
                                                           :fields-msgs-details="fields.message_detail"
                                                           :rows-per-page="consts.general.rows_per_page"/>
                                        </b-tab>

                                        <b-tab title="Device Alert History">
                                            <b-table
                                                primary-key="id"
                                                emptyText="There are no alerts to show"
                                                striped
                                                :id="`alert-table`"
                                                :per-page="perPage"
                                                :current-page="currentPage"
                                                :items="alert_history"
                                                :fields="fields.alert_history"
                                            >
                                                <template v-slot:cell(duration)="item">
                                                    {{ item.item | display_duration }}
                                                </template>

                                                <template v-slot:cell(value)="item">
                                                    {{ item.item | compute_alert_value }}
                                                </template>

                                                <template v-slot:cell(threshold)="item">
                                                    {{ item.item | display_threshold }}
                                                </template>
                                            </b-table>

                                            <b-row v-if="alert_history.length > 20" class="my-5">
                                                <b-col>
                                                    <b-pagination
                                                        v-model="currentPage"
                                                        :total-rows="totalRows"
                                                        :per-page="perPage"
                                                        align="center"
                                                    >
                                                    </b-pagination>
                                                </b-col>
                                            </b-row>
                                        </b-tab>
                                    </b-tabs>
                                </b-card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal id="modal-edit-address" title="Edit Address" size="lg"  v-model="modal_edit_address">
            <template v-slot:modal-header-close>
                <b-button size="sm" class="close" variant="null" @click="toggle_address_modal">x</b-button>
            </template>
            <b-form @submit.prevent="register">
                <b-form-group label="Address Line 1:" label-for="input-1b">
                    <b-form-input id="input-1b" v-model="device_address.line_1" type="text" required/>
                </b-form-group>
                <b-form-group label="Address Line 2:" label-for="input-1b">
                    <b-form-input id="input-1b" v-model="device_address.line_2" type="text" required/>
                </b-form-group>
                <b-form-group label="City:" label-for="input-2b">
                    <b-form-input id="input-2b" v-model="device_address.city" type="text" required/>
                </b-form-group>
                <b-form-group label="State:">
                    <b-form-select required v-model="device_address.state" :options="stateOptions" id="3-b"/>
                </b-form-group>
                <b-form-group label="Zip Code:" label-for="input-4b">
                    <b-form-input id="input-4b" v-model="device_address.zip" type="email" required/>
                </b-form-group>
            </b-form>
            <template v-slot:modal-footer="{ ok }">
                <b-button variant="dark" @click="edit_address" class="mr-4 my-2"> Save </b-button>
            </template>
        </b-modal>

        <b-modal v-if="device" id="modal-edit-device" title="Edit Device" size="lg"  v-model="modal_edit_device">
            <template v-slot:modal-header-close>
                <b-button size="sm" class="close" variant="null" @click="toggle_device_modal">x</b-button>
            </template>
            <b-form @submit.prevent="register">
                <b-form-group label="Device Name:" label-for="input-1b">
                    <b-form-input id="input-1b" v-model="device.name" type="text" required/>
                </b-form-group>
            </b-form>
            <template v-slot:modal-footer="{ ok }">
                <b-button variant="dark" @click="edit_device" class="mr-4 my-2"> Save </b-button>
            </template>
        </b-modal>

    </div>

</template>

<script>
    import KDeviceLocationCrud from '../../widgets/DeviceLocationCrud'
    import {get_device_detail, update_device_address, update_device, create_device_address} from '../../networking/devices'
    import { get_alert_history } from '../../networking/alerts'
    import { get_sensor_messages} from '../../networking/messages'

    import { stateOptions } from '../../helpers/address'
    import deviceApi from '../../device_apis'
    import messageApi from '../../message_apis'
    import moment from 'moment'
    import KSensorList from '../../widgets/SensorList'
    import axios from 'axios'
    import { msg_root } from '../../networking/messages'


    const capitalize = value => value ? String(value).charAt(0).toUpperCase() + String(value).slice(1).toLowerCase() : ''

    const address_fields = [
        { key: 'line_1', label: 'Address Line 1' },
        { key: 'line_2', label: 'Address Line 2' },
        { key: 'city' },
        {
            key: 'state', formatter: state => stateOptions.find(({ value }) => value == state)
                ? stateOptions.find(({ value }) => value == state).text : state
        },
        { key: 'zip' }
    ]

    const device_fields = [
        { key:'name', label: 'Device Name' },
        { key:'device_type_name', label: 'Device Type' },
        { key:'imei', label:'Serial' },
        //{ key:'time_zone' },
        { key:'status' },
        { key:'lastReportDateTime', label: 'Last Message Time'}
    ]

    const sensor_fields = [
        { key: 'podid', label: 'Sensor ID'},
        { key: 'sensor_type_name', label: 'Sensor', class:"d-none d-md-table-cell" },
        { key: 'status', class:"d-none d-md-table-cell" },
        { key: 'messages', label: 'Messages'},
    ]
    const sensor_msgs_fields = [
        { key: 'podId', label: 'Sensor ID', sortable: true },
        { key: 'sampleDateTime', label: 'Sample Time', sortable: true },
        { key: 'sensorType', sortable: true },
        { key: 'batteryVoltage', label: 'Battery', sortable: true },
        { key: 'temperature', label: 'Temp', sortable: true },
        { key: 'magX', sortable: true },
        { key: 'magY', sortable: true },
        { key: 'magZ', sortable: true },
        { key: 'detail' },
      ]
    const message_detail_fields = [
        { key: 'podId', label: 'Sensor ID', sortable: true},
        { key: 'sampleDateTime', label: 'Sample Time', sortable: true},
        { key: 'sensorType', sortable: true},
        { key: 'batteryVoltage', label: 'Battery', sortable: true},
        { key: 'temperature', label: 'Temp', sortable: true},
        { key: 'magX', sortable: true},
        { key: 'magY', sortable: true},
        { key: 'magZ', sortable: true},
        { key: 'magDx', label: 'Mag Dx' },
        { key: 'magDy', label: 'Mag Dy' },
        { key: 'magDz', label: 'Mag Dz' },

        { key: 'packetPayload', label: 'Sample Payload' },
        { key: 'secondsSinceLastRead', label: 'Seconds Since Last Read' },
        { key: 'inboundMessageId', label: 'Inbound Message Id' },
        { key: 'imei', label: 'Imei' },
        { key: 'txCount', label: 'Tx Count' }
    ]


    const alert_fields = [
        { key: 'alertName', label:'Name', sortable: true },
        { key: 'alertTypeDesc', label: 'Type', sortable: true },
        { key: 'threshold', label: 'Threshold', sortable: true, formatter: v => `${v} GPM` },
        { key: 'action', label: '', sortable: false }
    ]

    const alert_history_fields = [
        { key: 'alertDesc', label: 'Alert Type' },
        { key: 'status', formatter: v => capitalize(v), class:"alert-status" },
        { 
            key: 'startDateTime', 
            label: 'Triggered', 
            formatter: value => value ? moment((new Date(value))).format('YYYY-MM-DD hh:mm:ss a') : null, 
            class:"d-none d-md-table-cell alert-triggered", 
            sortable: true 
        },
        { key: 'duration', class:"d-none d-md-table-cell" },
        { key: 'value', class:'d-none d-md-table-cell' },
/*
        {
            key: 'magY',
            label: 'Value',
            class:"d-none d-md-table-cell",
            formatter: v => `${convert_magY_to_gpm(v)} GPM`
*/
        {
            key: 'threshold', 
            label: 'Threshold', 
            class:"d-none d-md-table-cell", 
            formatter: v => `${v} GPM` 
        },
//        { key: 'detail' } TO DO ?
    ]

    const compute_alert_duration = ({ status, startDateTime, endDateTime }) => status === 'OPEN'
        ?   moment.duration(moment(startDateTime).diff(moment(new Date))).humanize()
        :   moment.duration(moment(startDateTime).diff(moment(endDateTime))).humanize()

    export default {
        props: {
            id: { type: String, required: true }
        },
        components: { KDeviceLocationCrud, KSensorList },
        data(){
            return {

                stateOptions: stateOptions,

                fields:{ 
                    device:device_fields,
                    address_fields:address_fields,
                    sensors: sensor_fields,
                    sensor_msgs: sensor_msgs_fields,
                    message_detail: message_detail_fields,
                    alert_history: alert_history_fields,
                },

                device: null,
                sensors: [],

                alert_history: [],
                modal_edit_device: false,
                modal_edit_address: false,

                tableName: 'device',
                tabIndex: 0,
                disable_valve_control: true,
                valve_status: false,
                troubleshooting_mode_supported: false,
                troubleshooting_mode_time: null,
                lastReportDateTime: null,
                rssi: null,
                batteryPct: null,
                perPage: 20,
                totalRows: 0,
                currentPage: 1,

                device_address: {},

                loading: {
                    sensorList: false    
                }
            }
        },

        async created(){
            this.loading.sensorList = true;
            const generator = get_device_detail(this.id)
            const { value: { data = {} } } = await generator.next()
            const { 
                device = {},
                sensors = [],
                alert_profiles = [],
                device_address = {},
                device_info = {}
            } = data

            this.device = device
            this.sensors = sensors
            this.device_address = device_address
            this.disable_valve_control = !device_info.valve_supported
            this.valve_status = device_info.valve_status === 'open' || !device_info.valve_supported
            this.troubleshooting_mode_supported = device_info.troubleshooting_mode_supported
            this.troubleshooting_mode_time = device_info.troubleshooting_mode_time
            this.rssi = device_info.rssi
            this.batteryPct = device_info.battery_pct
            this.lastReportDateTime = device_info.lastReportDateTime

            const { value: { data: alert_history = [] }} = await get_alert_history({ imei: device.imei, sort_asc: false })
            this.alert_history = alert_history

            this.loading.sensorList = false;
        },

        methods: {
            get_rssi_img() {
                if (this.rssi < -103)
                  return "/icons/rssi-1.png"
                else if (this.rssi < -97)
                  return "/icons/rssi-2.png"
                else if (this.rssi < -89)
                  return "/icons/rssi-3.png"
                else if (this.rssi < -78)
                  return "/icons/rssi-4.png"
                else
                  return "/icons/rssi-5.png"
            },
            get_batt_img() {
                return "/icons/batt-" + this.batteryPct + ".png"
            },
            toggle_device_modal(){ this.modal_edit_device = !this.modal_edit_device },
            toggle_address_modal(){ this.modal_edit_address = !this.modal_edit_address },

            async updateValveControl() {
                if (confirm('WARNING: Improper actuation could lead to damages and water loss')) {
                    this.$emit('showAlert', 'Updating Your Valve Status', 'info')

                    this.valve_status = !this.valve_status
                    try {
                        await deviceApi.toggleValveState(this.id, this.valve_status ? 1 : 0)
                        this.$emit('showAlert', 'Valve Status Updated', 'success', 1800)
                    } catch (e) {
                        this.$emit('showAlert', 'Error Updating Valve Status', 'error', 3600)
                    }
                }
            },
            async updateTroubleshootingMode() {
                try {
                  if (this.troubleshooting_mode_supported)
                    await messageApi.disable_troubleshooting_mode_support(this.device.imei)
                  else
                    await messageApi.enable_troubleshooting_mode_support(this.device.imei)

                  this.troubleshooting_mode_supported = !this.troubleshooting_mode_supported

                  this.$emit('showAlert', 'Request to Change Troubleshooting Mode Support Received', 'success', 1800)


                } catch (e) {
                  this.$emit('showAlert', 'Error Changing Troubleshooting Mode Support', 'error', 3600)
                }
            },
            async edit_address(){
                this.modal_edit_address = !this.modal_edit_address
                this.$emit('showAlert', 'Updating Address', 'info')
                if (this.device_address.id == null) {
                    this.device_address.device_id = this.device.id
                    const admin_generator = create_device_address(this.device_address)
                    const { value: { data }} = await admin_generator.next()
                    this.device_address.id = data.id
                } else {
                    const admin_generator = update_device_address(this.device_address)
                    const { value: { data }} = await admin_generator.next()
                }
                this.$emit('showAlert', 'Updated Address', 'success', 1800)
            },

            async edit_device(){
                this.modal_edit_device = !this.modal_edit_device
                this.$emit('showAlert', 'Updating Device', 'info')
                const admin_generator = update_device(this.device)
                const { value: { data }} = await admin_generator.next()
                this.$emit('showAlert', 'Updated Device', 'success', 1800)
            },

            update_location(device_address) {
                this.device_address = device_address
            },

            async retrieve_sensor_mgs(sensor){
                const { value: { data } } = await get_sensor_messages({ 
                    podId: sensor.podid, 
                    fromDate: moment().subtract(14, 'days'), 
                    toDate: moment() 
                })
                return data;
            },
            async download_data(podid){
                this.$emit('showAlert', 'Preparing your data...', 'info')

                axios.defaults.headers.common.Accept = {}
                axios.get(
                    `${msg_root}messages/downloadCP/${podid}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        },
                        responseType: 'blob'
                    }
                ).then((response) => {
                    axios.defaults.headers.common.Accept = 'application/json'
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute(
                        'download',
                        `Sensor-${podid} Konametrix Data ${moment().format('MM-DD-YY')}.xlsx`
                    )
                    document.body.appendChild(link)
                    link.click()

                    this.$emit('showAlert', 'Download Completed!', 'success', 3500)
                }).catch(e => {
                    axios.defaults.headers.common.Accept = 'application/json'
                    this.$emit('showAlert', 'Sensor data could not be downloaded.', 'danger')
                    console.log(e)
                })

                console.log("downloading...");
            },
        },

        filters: { 
            capitalize: value => value ? String(value).charAt(0).toUpperCase() + String(value).slice(1) : '',
            display_duration: item => compute_alert_duration(item),
            display_threshold: ({ alertType, eventData = '{}', threshold, magZ }) => ({
                'LEAK': `${threshold} hrs`,
                'BATTERY': `${threshold} mV`,
                'LOWFLOW': `${threshold} GPM`,
                'LOWPRESSURE': `${Math.round((magZ/100 + Number(threshold))*10)/10} psi`,
                'LOWLEVEL': `${threshold} in`,
                'HIGHLEVEL': `${threshold} in`,
                'DEVICE_BATTERY': `${threshold} mV`,
                'WATER_NUMBER': JSON.parse(eventData).previousWaterNumberAverage,
                'COMMUNICATION': `8 hrs`
            })[alertType],

            compute_alert_value: ({ 
                alertType, gpm, waterLevelInches, psi, batteryVoltage, threshold, magY, eventData = '{}', ...alert 
            }) => ({
                'LEAK': `${threshold} hrs`,
                'BATTERY': `${batteryVoltage } mV`,
                'LOWFLOW': `${gpm} GPM`,
                'LOWPRESSURE': `${magY/100} psi`,
                'LOWLEVEL': `${waterLevelInches} in`,
                'HIGHLEVEL': `${waterLevelInches} in`,
                'DEVICE_BATTERY': `${batteryVoltage } mV`,
                'WATER_NUMBER': JSON.parse(eventData).waterNumber,
                'COMMUNICATION': `${compute_alert_duration(alert)}`
            })[alertType]
        },

        watch:{
            alert_history(items){ this.totalRows = items.length }
        }        
    }

</script>

<style>

    .btn-open {
        color: #fff !important;
        border: none !important;
        background-color: green !important;
    }

    .btn-close {
        color: #fff !important;
        border: none !important;
        background-color: crimson !important;
    }

    .nav-link .nav-link.active {
        text-color: black;
        margin:5px;
    }

    .nav-link {
        margin-right:3px;
    }

    .nav-tabs .nav-link.active {
        background-color: #296a9b;
        color: #fff !important;
    }

    .nav-tabs .nav-link {
        background-color: #eeeeee;
    }

</style>

